import React from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import { RouteUrl, useGetMatchPage } from '@utils/routeUtil';

import RouterQuery, { UtmOrigin } from '@utils/routeUtil/RouterQuery';
import classnames from 'classnames/bind';
import styles from './preparation.module.scss';
const cx = classnames.bind(styles);

const JobPreparation = () => {
  const matchUrl = useGetMatchPage();

  return (
    // 취업준비 영역
    <div className={cx('preparationListArea')}>
      <em className={cx('preparationTitle')}>취업준비</em>
      <ul className={cx('preparationList')}>
        <li className={cx('listItem')}>
          <Link
            href={{ pathname: RouteUrl.PROFILE, query: RouterQuery.getUtmSource(UtmOrigin.Preparation) }}
            legacyBehavior
          >
            <a className={cx('link')} role="button">
              <div className={cx('icon')}>
                <Icon name="infoUser" />
              </div>
              <div className={cx('infoArea')}>
                <div className={cx('infoTitle')}>내 프로필</div>
                <p className={cx('infoDesc')}>
                  프로필을 미리 작성해두면
                  <br />
                  입사지원할 때 편하게 불러갈 수 있어요.
                </p>
              </div>
            </a>
          </Link>
        </li>
        <li className={cx('listItem')}>
          <Link href={RouteUrl.INFO_LIST} legacyBehavior>
            <a className={cx('link')} role="button">
              <div className={cx('icon')}>
                <Icon name="bookGreen" />
              </div>
              <div className={cx('infoArea')}>
                <div className={cx('infoTitle')}>취업 콘텐츠</div>
                <p className={cx('infoDesc')}>
                  역검 준비 방법과 합격 후기부터
                  <br />
                  재직자들의 취업 비법 콘텐츠를 확인할 수 있어요.
                </p>
              </div>
            </a>
          </Link>
        </li>
        <li className={cx('listItem')}>
          <Link href={matchUrl} legacyBehavior>
            <a className={cx('link')} role="button">
              <div className={cx('icon')}>
                <Icon name="resumeDoneGreen" />
              </div>
              <div className={cx('infoArea')}>
                <div className={cx('infoTitle')}>잡다매칭</div>
                <p className={cx('infoDesc')}>
                  잡다매칭 참여하면
                  <br />
                  내게 관심 있는 기업으로부터 먼저 제안 받을 수 있어요.
                </p>
              </div>
            </a>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default JobPreparation;
